import { useApplicationByEdition } from "./application-by-edition.hook";
import { useCurrentUserProfile } from "./current-user-profile.hook";
import { useQuizById } from "./quiz-by-id.hook";

/**
 * Returns the current quiz for the given edition.
 *
 * @param editionId - The ID of the edition to get the quiz for.
 * @returns The current quiz data. Uses Tanstack Query cache.
 */
export const useCurrentQuiz = (editionId: string) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  return useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: application?.quizId || "",
  });
};
